import styled from 'styled-components';
import { motion } from 'framer-motion';

export const Main = styled.section`
  padding: 110px 0 130px;
  position: relative;
  z-index: 10;
  background:
    radial-gradient(circle at 18% 30%, ${(props) => props.theme.text}12 0%, transparent 42%),
    #050505;

  @media screen and (max-width: 768px) {
    padding: 80px 0 90px;
  }
`;

export const MaxWidth = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    padding: 0 22px;
  }
`;

export const Title = styled(motion.h2)`
  text-align: center;
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${(props) => props.theme.text};
  margin-bottom: 10px;
`;

export const Heading = styled(motion.h1)`
  text-align: center;
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 70px;
  font-family: 'Poppins', sans-serif;

  @media screen and (max-width: 768px) {
    font-size: 30px;
    margin-bottom: 50px;
  }
`;

export const Timeline = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 34px;
`;

/* The vertical spine + animated progress fill */
export const Spine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 50%;
  width: 2px;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.1);
  overflow: hidden;

  @media screen and (max-width: 820px) {
    left: 22px;
  }
`;

export const SpineFill = styled(motion.div)`
  position: absolute;
  inset: 0;
  transform-origin: top;
  background: linear-gradient(
    180deg,
    ${(props) => props.theme.text} 0%,
    ${(props) => props.theme.text}55 100%
  );
`;

export const Row = styled.div`
  position: relative;
  display: flex;
  justify-content: ${({ $side }) => ($side === 'left' ? 'flex-start' : 'flex-end')};

  @media screen and (max-width: 820px) {
    justify-content: flex-start;
    padding-left: 56px;
  }
`;

/* The dot sitting on the spine */
export const Node = styled(motion.span)`
  position: absolute;
  display: block;
  top: 34px;
  left: 50%;
  /* center via negative margins (transform is owned by framer-motion's scale animation) */
  margin-left: -7.5px;
  margin-top: -7.5px;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: ${(props) => props.theme.text};
  box-shadow: 0 0 0 5px ${(props) => props.theme.text}26,
    0 0 18px ${(props) => props.theme.text}aa;
  z-index: 2;

  @media screen and (max-width: 820px) {
    left: 22px;
  }
`;

export const Card = styled(motion.div)`
  width: calc(50% - 44px);
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 22px 26px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  backdrop-filter: blur(10px);
  transition: transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease;

  &:hover {
    transform: translateY(-4px);
    border-color: ${(props) => props.theme.text};
    box-shadow: 0 20px 50px -24px ${(props) => props.theme.text};
  }

  @media screen and (max-width: 820px) {
    width: 100%;
  }
  @media screen and (max-width: 520px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 14px;
    padding: 20px;
  }
`;

export const Logo = styled.div`
  flex-shrink: 0;
  width: 58px;
  height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 20px;
  font-weight: 800;
  color: ${(props) => props.theme.text};
  background: #ffffff;
  border: 2px dashed ${(props) => props.theme.text}80;
  overflow: hidden;
  padding: 9px;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Role = styled.h3`
  font-size: 19px;
  font-weight: 700;
  color: #fff;
  line-height: 1.25;

  @media screen and (max-width: 520px) {
    font-size: 17px;
  }
`;

export const Company = styled.p`
  font-size: 14px;
  color: #8b94a3;
  margin-top: 3px;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const Kind = styled.span`
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  padding: 3px 9px;
  border-radius: 999px;
  color: ${(props) => props.theme.text};
  background: ${(props) => props.theme.text}1c;
  border: 1px solid ${(props) => props.theme.text}3a;
`;

export const Dates = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #cbd2de;
  white-space: nowrap;

  svg {
    color: ${(props) => props.theme.text};
    font-size: 16px;
  }

  span.now {
    color: ${(props) => props.theme.text};
  }
`;
